import React from "react";
import RolePermissionTable from "./RolePermissionTable";
import { showError } from "utils/notifications";

/**
 * RolePermissionListForm Component
 * Renders a list of permission tables for different menu sections.
 * Handles interaction restrictions based on user permissions and selection state.
 */
const RolePermissionListForm = ({
  parentMenu,
  menuList,
  roleMenuAccess,
  rolePermissions,
  onPermissionChange,
  onParentPermissionChange,
  RESTRICTED_PERMISSIONS,
  rolePermission
}) => {
  // Determine if the form should be non-interactive (e.g., no role selected)
  const isInteractionRestricted = !rolePermissions;

  /**
   * Handles clicks on the restricted wrapper.
   * Prioritizes 'Permission' errors over 'Selection' errors.
   */
  const handleWrapperClick = () => {
    if (!rolePermission) {
      showError("Access Denied: You do not have permission to modify these settings.");
      return;
    }
    
    if (isInteractionRestricted) {
      showError("Action Required: Please select a role from the list first.");
    }
  };

  return (
    <div
      className={`role-permission-form-wrapper ${isInteractionRestricted || !rolePermission ? "opacity-75 cursor-not-allowed" : ""}`}
      onClick={handleWrapperClick}
      style={{ pointerEvents: "all" }}
    >
      <form className="row g-3">
        {parentMenu.map((pm) => (
          <div className="col-md-12 mb-4" key={pm.menu_id}>
            <RolePermissionTable
              parentMenu={pm}
              menuList={menuList.filter((m) => m.parent_menu === pm.menu_id)}
              roleMenuAccess={roleMenuAccess}
              rolePermissions={rolePermissions}
              onPermissionChange={onPermissionChange}
              onParentPermissionChange={onParentPermissionChange}
              RESTRICTED_PERMISSIONS={RESTRICTED_PERMISSIONS}
            />
          </div>
        ))}
      </form>
    </div>
  );
};

export default RolePermissionListForm;
